import type { ButtonHTMLAttributes } from 'react';

/** «Войти» and «Сохранить» are the same button in the handoff. */
export function PrimaryButton(props: ButtonHTMLAttributes<HTMLButtonElement>) {
  const { className, type = 'button', ...rest } = props;
  return (
    <button
      {...rest}
      type={type}
      className={className ? `primary-button ${className}` : 'primary-button'}
    />
  );
}
